import React from "react"
import styled, { keyframes } from "styled-components"
import SkeletonLoader from "./SkeletonLoader"

const ButtonLike = ({ handleLike, onNoVoting, loading, processing, hasLiked }) => {
  return (
    <>
      <LikeWrapper>
        <SkeletonLoader
          active={loading}
          width="40%"
          height="150px"
          borderRadius="100px"
          margin="40px auto"
          display="flex"
        >
          <LikeButton
            onClick={handleLike}
            disabled={loading || processing || hasLiked}
            aria-label="Dar like"
            $processing={processing}
          >
            {processing ? (
              <Spinner viewBox="0 0 50 50">
                <circle cx="25" cy="25" r="20" fill="none" />
              </Spinner>
            ) : (
              <CocaColaIcon viewBox="0 0 640 480">
                <image
                  href="/coca_cola_sin_margenes.svg"
                  width="640"
                  height="480"
                  preserveAspectRatio="xMidYMid meet"
                />
              </CocaColaIcon>
            )}
          </LikeButton>
        </SkeletonLoader>

        {processing && <ProcessingText>Enviando...</ProcessingText>}
      </LikeWrapper>

      <SkeletonLoader
        active={loading}
        width="40%"
        height="15px"
        borderRadius="15px"
        margin="0 auto"
        display="flex"
      >
        <NoVoteText
          onClick={!processing ? onNoVoting : undefined}
          style={{ opacity: processing ? 0.5 : 1 }}
        >
          Prefiero no valorar
        </NoVoteText>
      </SkeletonLoader>
    </>
  )
}

export default ButtonLike

/* ========= Styled Components ========= */

const LikeWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: 20px;
  min-height: 160px;
`

const LikeButton = styled.button`
  background: transparent;
  border: none;
  border-radius: 50%;
  width: 150px;
  height: 150px;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.1s ease, opacity 0.2s ease;

  &:hover:not(:disabled) {
    transform: scale(1.04);
  }

  &:active:not(:disabled) {
    transform: scale(0.95);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: ${({ $processing }) => ($processing ? 1 : 0.6)};
  }
`

const CocaColaIcon = styled.svg`
  width: 150px;
  height: 150px;
  display: block;
  pointer-events: none;
`

const rotate = keyframes`
  100% {
    transform: rotate(360deg);
  }
`

const dash = keyframes`
  0% {
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -124;
  }
`

const Spinner = styled.svg`
  animation: ${rotate} 2s linear infinite;
  width: 50px;
  height: 50px;
  display: block;

  & circle {
    stroke: #ff0102;
    stroke-width: 4px;
    stroke-linecap: round;
    animation: ${dash} 1.5s ease-in-out infinite;
  }
`

const ProcessingText = styled.span`
  margin-top: 10px;
  color: #ff0102;
  font-weight: 600;
  font-size: 14px;
  animation: fadeIn 0.3s;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-5px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`

const NoVoteText = styled.p`
  font-weight: 500;
  font-size: 14px;
  text-align: center;
  color: #707070;
  margin-top: 30px;
  cursor: pointer;
  transition: color 0.2s ease;

  &:hover {
    color: #ff0102;
  }
`
